import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Blogs from '../views/Blogs.vue'
import Profile from '../views/Profile.vue';
import ResetPassword from '../views/ResetPassword'
import CreatePost from '../views/CreatePost'
import NotFound from '../views/NotFound'
import BlogPreview from '../views/BlogPreview'
import SingleBlog from '../views/SingleBlog'
import UserBlogs from '../views/UserBlogs'
import { appAuth } from '../firebase/firebaseConfig.js'
import firebase from "firebase/app";
import "firebase/auth";
import store from '../store';

const routes = [{
        path: '/:catchAll(.*)',
        component: NotFound,
        name: 'NotFound'
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Home',
            requiresAuth: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'Login',
            requiresAuth: false
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            title: 'Register',
            requiresAuth: false
        }
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            title: 'Reset-Password',
            requiresAuth: false
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
            title: 'Profile',
            requiresAuth: true
        }
    },
    {
        path: '/blogs',
        name: 'Blogs',
        component: Blogs,
        meta: {
            title: 'Blogs',
            requiresAuth: false
        }
    },
    {
        path: '/userblogs',
        name: 'UserBlogs',
        component: UserBlogs,
        meta: {
            title: 'UserBlogs',
            requiresAuth: true
        }
    },
    {
        path: '/createpost',
        name: 'CreatePost',
        component: CreatePost,
        meta: {
            title: 'CreatePost',
            requiresAuth: true
        }
    },
    {
        path: '/blogpreview',
        name: 'BlogPreview',
        component: BlogPreview,
        meta: {
            title: 'BlogPreview',
            requiresAuth: true
        }
    },
    {
        path: '/singleBlog/:blogid',
        name: 'SingleBlog',
        component: SingleBlog,
        meta: {
            title: 'SingleBlog',
            requiresAuth: false
        }
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | VueBlog`;
    next();
});

router.beforeEach(async(to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = await firebase.getCurrentUser();

    if (!isAuthenticated && requiresAuth) {
        next('/login')
    } else if (isAuthenticated && requiresAuth) {
        next()
    } else if (isAuthenticated && !requiresAuth) {
        if (to.path === '/login' || to.path === '/register') {
            next({
                path: '/',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router;